import { FormNewsletter } from './FormNewsletter'

export default FormNewsletter
